import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class DRMTask extends AbstractRequestTask {

  constructor(manifest) {
    super();
    this._manifest = manifest;
  }

  getMethod() {
    return 'GET';
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    return `${getAppConfig().end_point_middleware}drm-url?manifest=${this._manifest}`;
  }

  getParams() {
    return {};
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {
    console.log('DRMTask isValid ', data);
    return true;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default DRMTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/video/DRMTask.js